import { ChangeDetectionStrategy, Component, OnDestroy, afterNextRender, effect, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';

import * as fromStore from '../../store';

import { getCookiePreferences } from '@teamfoster/sdk/cookie-ngrx';
import { ContentBlockContainerComponent } from 'src/app/content-blocks/containers/content-block-container/content-block-container/content-block-container.component';


import { HeaderGalleryComponent } from 'src/app/standalone/components/header-gallery/header-gallery.component';
import { ResetMenuTheme, SetMenuTheme } from 'src/app/store';
import { HeaderCardGridComponent } from 'src/app/standalone/components/header-card-grid/header-card-grid.component';
import { HeaderCardSliderComponent } from 'src/app/standalone/components/header-card-slider/header-card-slider.component';
import { HeaderLibraryComponent } from 'src/app/standalone/components/header-library/header-library.component';
import { LibrarySearchFieldComponent } from 'src/app/standalone/components/library-search-field/library-search-field.component';
import { HeaderStandardComponent } from 'src/app/standalone/components/header-standard/header-standard.component';
import { HeaderContentPageComponent } from 'src/app/standalone/components/header-content-page/header-content-page.component';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./landing-page.component.scss'],
    imports: [
        ContentBlockContainerComponent,
        HeaderGalleryComponent,
        HeaderCardGridComponent,
        HeaderCardSliderComponent,
        HeaderLibraryComponent,
        LibrarySearchFieldComponent,
        HeaderStandardComponent,
        HeaderContentPageComponent,
    ]
})
export class LandingPageComponent {
  private store = inject(Store);

  showAnchors = input(false);

  landingPage$ = this.store.selectSignal(fromStore.getSelectedLandingPage);
  cookiePreferences$ = this.store.selectSignal(getCookiePreferences);
}
